<template>
    <div>
        <ul>
            <li :class="sipVoicemail ? 'form-label' : 'form-label-first'">
                {{ $t('ROUTE_TYPE') }}
            </li>
            <li>
                <CicSelect
                    id="route_type"
                    :enabled="editing"
                    :value="route.type"
                    :options="types"
                    @input="(val) => updateFieldValue('type', val)"
                />
            </li>
        </ul>
        <Component
            :is="component"
            :access-type="accessType"
            :editing="editing"
            :route="route"
            v-bind="componentProps"
            @change="updateFieldValue"
        />
        <VoiceOptions
            v-if="[1, 2].includes(route.type)"
            :editing="editing"
            :route="route"
            :media-lists="$store.routeData.mediaLists"
            :sip-voicemail="sipVoicemail"
            :voicemail-profiles="$store.routeData.voicemailProfiles"
            @change="updateFieldValue"
        />
    </div>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';
    import { getRouteTypes, RouteType } from '@/utils/RouteCollectionUtils';
    import OnwardRoute from './OnwardRoute';
    import SIPTrunk from './SIPTrunk';
    import CustomService from './CustomService';
    import Centrex from './Centrex';
    import Voicemail from './Voicemail';
    import PlayPrompt from './PlayPrompt';
    import PercentageSplit from './PercentageSplit';
    import VoiceOptions from './VoiceOptions';

    export default {
        name: 'ServiceSelectorInner',
        components: {
            CicSelect,
            OnwardRoute,
            SIPTrunk,
            CustomService,
            Centrex,
            Voicemail,
            PlayPrompt,
            PercentageSplit,
            VoiceOptions,
        },
        props: {
            accessType: {
                type: Number,
                default: 0,
            },
            editing: {
                type: Boolean,
                default: false,
            },
            route: {
                type: Object,
                required: true,
            },
            sipVoicemail: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['change'],
        computed: {
            component() {
                switch (this.route.type) {
                    case RouteType.OnwardRoute:
                        return OnwardRoute.name;
                    case RouteType.SIPTrunk:
                        return SIPTrunk.name;
                    case RouteType.CustomService:
                        return CustomService.name;
                    case RouteType.Centrex:
                        return Centrex.name;
                    case RouteType.Voicemail:
                        return Voicemail.name;
                    case RouteType.PlayPrompt:
                        return PlayPrompt.name;
                    case RouteType.PercentageSplit:
                        return PercentageSplit.name;
                }

                return null;
            },
            componentProps() {
                const props = {};

                switch (this.route.type) {
                    case RouteType.SIPTrunk:
                        props.trunks = this.$store.routeData.trunks;
                        break;
                    case RouteType.CustomService:
                        props.scripts = this.$store.routeData.scripts;
                        break;
                    case RouteType.Centrex:
                        if ([0, 1].includes(this.accessType)) {
                            props.treatments = this.$store.routeData.treatments;
                        } else {
                            props.treatments = this.$store.routeData.treatments.filter(
                                (treatment) => treatment.type === 3,
                            );
                        }
                        props.users = this.$store.routeData.users;
                        break;
                    case RouteType.Voicemail:
                        props.profiles = this.$store.routeData.voicemailProfiles;
                        break;
                    case RouteType.PlayPrompt:
                        props.mediaLists = this.$store.routeData.mediaLists;
                        break;
                    case RouteType.PercentageSplit:
                        props.profiles = this.$store.routeData.splitProfiles;
                        break;
                }

                return props;
            },
            types() {
                // sipVoicemail = false for auto attendant / percentage split and do not want web conference manager
                // for that; so reuse flag
                return getRouteTypes(this.route.type, this.accessType)
                    .filter((type) => type.id !== RouteType.WebConferenceManager || this.sipVoicemail)
                    .map((type) => ({
                        value: type.id,
                        label: this.$t(type.name),
                    }));
            },
        },
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
